import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-freshpass-lto',
  templateUrl: './freshpass-lto.component.html',
  styleUrls: ['./freshpass-lto.component.scss']
})
export class FreshpassLtoComponent {

  hasCoupons: boolean = false;
  @Input() logoProps: any = {};
  @Input() carouselData: any;
  @Input() authUserInfo: any;
  @Input() currentEnvironment: any;
  @Input() public configObj = {
    appName: '',
    programType: '',
  };

  coupons: any;
}